import { useAccount } from '../../services/settings/hooks/useAccount';
import { Customer } from './fragments/gql/Customer';

export const useAllCustomers = (): Customer[] => {
  const settings = useAccount();

  return settings.customers ?? [];
};
